/** @jsxImportSource @emotion/react */

import React from 'react';
import { CSSProp } from '../../../types/emotion';

export interface RaisedBoxProps {
  /**
   * The content to display inside the raised box.
   */
  children: React.ReactNode;
}

export function RaisedBox({
  children,
  ...props
}: RaisedBoxProps & Omit<Partial<React.HTMLAttributes<HTMLDivElement>>, keyof RaisedBoxProps> & CSSProp) {
  return (
    <div css={{ padding: '1.5rem', boxShadow: '0 0 0.5rem 0 #00000040' }} {...props}>
      {children}
    </div>
  );
}
